// extracted by mini-css-extract-plugin
export default {"actionBox":"actionBox--tcTsm","canDrop":"canDrop--XpfiR","dropzoneActive":"dropzoneActive--etuUZ"};